export default __webpack_public_path__ + "static/media/chrome-phone-1.f60d6ed0.jpg";